import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const itemColdefs = [
    {
        field: "srNo",
        headerName: "Sr, no",
        minWidth: window.innerWidth * 0.05,
        valueGetter: "node.rowIndex + 1",
        flex: 0.5,
        filter: true,
    },
    {
        field: "description",
        headerName: "Description",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "weight",
        headerName: "Weight",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },

];

export const GatePassPopup = (props) => {
    return (
        <ModalBasic
            id="gatepass"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Gate pass details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Sr. no</label>
                        <TextInput type='text'
                            id='gatePassNo' name='gatePassNo'
                            value={props.gatePassObject.gatePassNo}
                            handleChange={(event) => props.handleChangeForGatePass(event, 'gatePassNo')}
                            className={props.validState?.error?.gatePassNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='date' name='date'
                            value={props.gatePassObject.date}
                            handleChange={(event) => props.handleChangeForGatePass(event, 'date')}
                            className={props.validState?.error?.date !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Vehicle no</label>
                        <TextInput type='text'
                            id='vehicleNo' name='vehicleNo'
                            value={props.gatePassObject.vehicleNo}
                            handleChange={(event) => props.handleChangeForGatePass(event, 'vehicleNo')}
                            className={props.validState?.error?.vehicleNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Person</label>
                        <TextInput type='text'
                            id='personName' name='personName'
                            value={props.gatePassObject.personName}
                            handleChange={(event) => props.handleChangeForGatePass(event, 'personName')}
                            className={props.validState?.error?.personName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Party name</label>
                        <MultiSelectDropdown
                            drpIdentity="Select party"
                            options={props.partyAccountList}
                            value={props.gatePassObject.partyName ? props.partyAccountList.find(x => x.value === props.gatePassObject.partyName) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "partyName")
                            }
                            className={props.validState?.error?.partyName !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Challan no</label>
                        <TextInput type='text'
                            id='challanNo' name='challanNo'
                            value={props.gatePassObject.challanNo}
                            handleChange={(event) => props.handleChangeForGatePass(event, 'challanNo')}
                            className={props.validState?.error?.challanNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Challan date</label>
                        <TextInput type='date'
                            id='challanDate' name='challanDate'
                            value={props.gatePassObject.challanDate}
                            handleChange={(event) => props.handleChangeForGatePass(event, 'challanDate')}
                            className={props.validState?.error?.challanDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Ref. 1</label>
                        <TextInput type='text'
                            id='ref1' name='ref1'
                            value={props.gatePassObject.ref1}
                            handleChange={(event) => props.handleChangeForGatePass(event, 'ref1')}
                            className={props.validState?.error?.ref1 !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Ref. 2</label>
                        <TextInput type='text'
                            id='ref2' name='ref2'
                            value={props.gatePassObject.ref2}
                            handleChange={(event) => props.handleChangeForGatePass(event, 'ref2')}
                            className={props.validState?.error?.ref2 !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Gate pass description details</span>
                <div className='item-inner grid grid-cols-4 items-start gap-2.5 mt-2'>
                    <div className='input-grp col-span-2 row-span-2'>
                        <label>Description</label>
                        <textarea rows={4}
                            id='description' name='description'
                            value={props.itemObject.description}
                            onChange={(event) => props.handleChange(event, 'description')}
                            className={`h-full ${props.validState?.error?.description !== undefined ? "error" : ""}`}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChange(event, 'quantity')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Weight</label>
                        <TextInput type='number'
                            id='weight' name='weight'
                            value={props.itemObject.weight}
                            handleChange={(event) => props.handleChange(event, 'weight')}
                            className={props.validState?.error?.weight !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 '>
                        {/* {props.itemObject.keyId > 0 ?
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Update")}>Update</button>
                            :
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }

                        <button className="delete-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.clear()}>Delete</button> */}
                        {props.itemObject && props.itemObject.index === null ?
                            <div className="input-grp">
                                <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.insertItem("Insert")}> Insert</button>
                            </div>
                            :
                            <div className="input-grp flex items-center gap-2.5">
                                <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.insertItem("Update")}> Update</button>
                                <button className="delete-btn btns mt-auto mb-[2px]" onClick={() => props.deleteItem()}> Delete</button>
                            </div>
                        }
                    </div>
                </div>
                <div className="process-table h-[30vh] mt-5">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}